import { Modal, Header, Button, Input } from 'semantic-ui-react';

function EditProject({ current_project, updateCurrentProject, open, handleClose, handleSaveProject, saving }) {
	const action_text  = current_project.id ? `Save` : `Add`;
	const modal_header = `${action_text} Project`;

	function handleChange(e) {
		updateCurrentProject(e);
	}

	return (
		<Modal
			size="mini"
			closeIcon
			open={open}
			onClose={handleClose}
		>
			<Header content={modal_header} />

			<Modal.Content>
				<Input fluid focus placeholder="Project name" name="title" value={current_project.title} onChange={(e) => handleChange(e)} />
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleClose}>Cancel</Button>
				<Button color="green" loading={saving} onClick={() => handleSaveProject(current_project)}>{action_text}</Button>
			</Modal.Actions>
		</Modal>
	);
}

export default EditProject;
